import React from 'react';
import { any, bool, func, number } from 'prop-types';
import animate from './animation';

/**
 * For icons or logos from the API
 * Also for static icons which need to rotate dynamically
 */

DynamicIcon.propTypes = {
  logoRectSize: number,
  animation: bool,
  rotate: number,
  onClick: func,
  x: number,
  y: number,
  href: any,
};

function DynamicIcon(props) {
  const {
    x,
    y,
    href,
    rotate,
    onClick,
    animation,
    logoRectSize
  } = props;
  const thisRef = React.useRef();

  React.useEffect(() => {
    if (animation && thisRef.current) {
      const iconContainer = thisRef.current;
      const img = iconContainer.querySelector('image');
      animate(iconContainer, img);
    }
  }, ['didMount']);
  return (
    <g transform={`rotate(-${rotate} ${x} ${y})`} onClick={onClick}>
      <g transform={`translate(${x - logoRectSize / 2} ${y - logoRectSize / 2})`}>
        <g className={animation && "container_icon"} ref={thisRef}>
          <image width={logoRectSize} height={logoRectSize} href={href || undefined} />
        </g>
      </g>
    </g>
  );
};

DynamicIcon.defaultProps ={
  logoRectSize: 16
}

export default DynamicIcon;